import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/sheet';
import { ENTITY_CARDS, EntityContext, resolveFishId } from './cards';

export type SelectedEntity = { index: string; label: string; hit: Record<string, any> };

export function EntityInspector({
  selected,
  onClose,
}: {
  selected: SelectedEntity | null;
  onClose: () => void;
}) {
  const ctx: EntityContext | null = selected
    ? { index: selected.index, hit: selected.hit, fishId: resolveFishId(selected.index, selected.hit) }
    : null;

  return (
    <Sheet open={!!selected} onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-lg">
        <SheetHeader>
          <SheetTitle>{selected?.label ?? 'Details'}</SheetTitle>
        </SheetHeader>
        <SheetBody className="space-y-4">
          {ctx &&
            ENTITY_CARDS.filter((card) => card.shouldRender(ctx)).map((card) => (
              <card.Component key={card.id} {...ctx} />
            ))}
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
